import BaseApi from "./baseApi";

class SampleContentApi extends BaseApi {
  async getSampleContent(contentType: string, language: string): Promise<any> {
    return await this.API({
      url: `/sample-content/get-content?contentType=${encodeURIComponent(contentType)}&language=${encodeURIComponent(language)}`,
      method: "get"
    });
  }

  async updateSampleContent(data: Record<string, unknown> | object): Promise<any> {
    return await this.API({
      url: "/sample-content/update-content",
      data: data,
      method: "post"
    });
  }
}

export default SampleContentApi;
